<div
  id="notification"
  class="notification"
  [ngClass]="'notification--' + _variant"
  >
  <svg
    viewBox="0 0 100 100"
    class="notification-icon"
    [ngClass]="'notification-icon--' + _variant"
    >
    @if (_variant === 'error') {
      <use
        href="assets/icons-v2/sprites.svg#error-diamond-bold"
      ></use>
    }
    @if (_variant === 'warning') {
      <use
        href="assets/icons-v2/sprites.svg#warning-triangle-bold"
      ></use>
    }
    @if (_variant === 'success') {
      <use
        href="assets/icons-v2/sprites.svg#check-circle-bold"
      ></use>
    }
    @if (_variant === 'information') {
      <use
        href="assets/icons-v2/sprites.svg#information-circle-bold"
      ></use>
    }
  </svg>
  <div class="notification-message be-body-text--sm">
    <ng-content></ng-content>
  </div>
</div>
